import Image from 'next/image';
import type { AuthorProfile } from '@/types/blog';

interface AuthorCardProps {
  author: AuthorProfile;
}

export default function AuthorCard({ author }: AuthorCardProps) {
  const fallbackName = author.image_from ?? author.name;
  return (
    <div className="mt-8 flex items-start gap-5 rounded-lg border border-border bg-card/50 p-5">
      <div className="shrink-0">
        {author.image_url ? (
          <div className="relative h-20 w-20 overflow-hidden rounded-full">
            <Image
              src={author.image_url}
              alt={author.name}
              fill
              className="object-cover"
              sizes="80px"
              data-ai-hint={author.image_ai_hint || 'author portrait'}
            />
          </div>
        ) : (
          <div
            className="flex h-20 w-20 items-center justify-center rounded-full bg-muted font-display text-2xl font-semibold"
            style={{ color: 'var(--signal)' }}
            aria-hidden
          >
            {fallbackName.slice(0, 1).toUpperCase()}
          </div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-display font-semibold text-foreground">{author.name}</p>
        {author.role && (
          <p className="font-mono text-[0.7rem] uppercase tracking-wider text-muted-foreground">
            {author.role}
          </p>
        )}
        {author.bio && (
          <p className="mt-1.5 text-sm text-foreground/80 font-body">{author.bio}</p>
        )}
      </div>
    </div>
  );
}
